import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterOutlet]
})
export class AppComponent implements OnInit {
  title = 'frontend-landing';
  appVersion = environment.appVersion;
  envType = environment.type;
  isProd = environment.production;
  ngOnInit() {
    const hostElement = document.querySelector('app-root');
    if (hostElement) {
      hostElement.setAttribute('data-app-info', `V-${this.appVersion} ${this.isProd ? '' : this.envType}`);
    }
  }
}
